import LazyLoadImage from './index.vue'

export default function install(app) {
  app.component('LazyLoadImage', LazyLoadImage)
}
